import { useQuery } from '@tanstack/react-query'
import { listRecurring } from '@/api/recurring'
import { isDueNow } from '@/components/recurring/dueLabel'

/** Reminders due today or late, for the badge next to Recurring in the navigation. */
export function useDueRecurringCount(enabled: boolean): number {
  const { data } = useQuery({
    queryKey: ['recurring', 'due_soon'],
    queryFn: () => listRecurring('due_soon'),
    enabled,
  })
  return (data?.items ?? []).filter((item) => isDueNow(item.nextDueDate)).length
}
